import { create } from "zustand";

export type CameraMode = "orbit" | "firstPerson";
export type QualityTier = "low" | "medium" | "high" | "ultra";

export interface ViewerState {
  sceneUrl: string | null;
  setSceneUrl: (url: string) => void;

  loading: boolean;
  loadProgress: number;
  loadError: string | null;
  setLoading: (loading: boolean) => void;
  setLoadProgress: (p: number) => void;
  setLoadError: (e: string | null) => void;

  cameraMode: CameraMode;
  setCameraMode: (m: CameraMode) => void;

  quality: QualityTier;
  setQuality: (q: QualityTier) => void;

  fps: number;
  drawnSplats: number;
  totalSplats: number;
  setStats: (s: { fps: number; drawnSplats: number; totalSplats: number }) => void;

  showHud: boolean;
  toggleHud: () => void;
}

export const useViewerStore = create<ViewerState>((set) => ({
  sceneUrl: null,
  setSceneUrl: (sceneUrl) => set({ sceneUrl }),

  loading: false,
  loadProgress: 0,
  loadError: null,
  setLoading: (loading) => set({ loading }),
  setLoadProgress: (loadProgress) => set({ loadProgress }),
  setLoadError: (loadError) => set({ loadError }),

  cameraMode: "orbit",
  setCameraMode: (cameraMode) => set({ cameraMode }),

  quality: "high",
  setQuality: (quality) => set({ quality }),

  fps: 0,
  drawnSplats: 0,
  totalSplats: 0,
  setStats: ({ fps, drawnSplats, totalSplats }) => set({ fps, drawnSplats, totalSplats }),

  showHud: true,
  toggleHud: () => set((s) => ({ showHud: !s.showHud })),
}));
